import { Box } from "@mui/material";

interface Props {
	src: string;
}

const sx = {
	backgroundSize: "250px auto",
	backgroundRepeat: "no-repeat",
	backgroundPosition: "center center"
};

export default function LogoViewer({ src }: Props) {
	return <Box height={200} sx={{ backgroundImage: `url(${src})`, mb: 2, ...sx, maxHeight: 140 }} />;
}
